import React from 'react';
import PropTypes from 'prop-types';
import { css, StyleSheet } from 'aphrodite';
import compose from 'recompose/compose';
import withState from 'recompose/withState';
import lifecycle from 'recompose/lifecycle';

import './index.css';

export var stylePropType = PropTypes.oneOfType([PropTypes.object, PropTypes.arrayOf(PropTypes.object)]);

var styles = void 0;
var iconLib = {};
var widthHeightRe = /<svg width="([^"]+)" height="([^"]+)"/;
var viewBoxRe = /viewBox="([^"]+)"/;
var idRe = /<g id="(icon-[^"]+)"/;

var enhance = compose(withState('iconMeta', 'setIconMeta', null), lifecycle({
  componentWillMount: function componentWillMount() {
    var _this = this;

    var src = this.props.src;


    if (Reflect.has(iconLib, src)) {
      // If the value is a promise, the icon is being fetched. Wait for it
      if (typeof iconLib[src].then === 'function') {
        iconLib[src].then(function () {
          return _this.props.setIconMeta(iconLib[src]);
        });
      } else {
        // Icon is already loaded
        this.props.setIconMeta(iconLib[src]);
      }
    } else {
      iconLib[src] = fetch(src, {
        method: 'GET',
        credentials: 'include',
        headers: { accept: 'image/webp,image/apng,image/*,*/*;q=0.8' }
      }).then(function (response) {
        return response.text();
      }).then(function (contents) {
        var vhMatch = contents.match(widthHeightRe);
        var viewBoxMatch = contents.match(viewBoxRe);
        var idMatch = contents.match(idRe);

        var meta = {};
        if (!idMatch) {
          // Error case. Not able to show the icon
          meta.error = true;
          return;
        }
        meta.id = idMatch[1];

        if (vhMatch) {
          meta.width = vhMatch[1];
          meta.height = vhMatch[2];
        }

        if (viewBoxMatch) {
          meta.viewBox = viewBoxMatch[1];
        } else if (vhMatch) {
          meta.viewBox = '0 0 ' + meta.width.replace('px', '') + ' ' + meta.height.replace('px', '');
        } else {
          // Error case. Not able to show the icon
          meta.error = true;
        }

        if (!meta.error) {
          var container = document.querySelector('#react-svg-icon-repo');
          if (!container) {
            container = document.createElement('div');
            container.setAttribute('id', 'react-svg-ikon-repo');
            container.setAttribute('style', 'display:none');
            document.body.appendChild(container);
          }
          container.innerHTML = container.innerHTML + ' ' + contents;
          iconLib[src] = meta;
          _this.props.setIconMeta(meta);
        }
      });
    }
  }
}));

var Icon = function Icon(_ref) {
  var iconMeta = _ref.iconMeta,
      style = _ref.style,
      fill = _ref.fill,
      color = _ref.color,
      stroke = _ref.stroke,
      className = _ref.className;

  if (iconMeta === null) {
    return null;
  }

  if (iconMeta.error) {
    return React.createElement(
      'div',
      { className: css(styles.errorContainer) },
      '?'
    );
  }

  var baseClassName = 'icon-container ' + className;
  if (color) {
    baseClassName = baseClassName + ' stroke fill';
  } else if (fill) {
    baseClassName = baseClassName + ' fill';
  } else if (stroke) {
    baseClassName = baseClassName + ' stroke';
  }

  var finalStyle = void 0;
  if (color) {
    finalStyle = { color: color };
  } else if (stroke) {
    finalStyle = { color: stroke };
  } else if (fill) {
    finalStyle = { color: fill };
  }

  var svgStyle = {
    width: style && style.width || iconMeta.width,
    height: style && style.height || iconMeta.height
  };

  return React.createElement(
    'div',
    {
      className: baseClassName + ' ' + css(styles.container, style),
      style: finalStyle
    },
    React.createElement(
      'svg',
      { viewBox: iconMeta.viewBox, style: svgStyle },
      React.createElement('use', { xlinkHref: '#' + iconMeta.id })
    )
  );
};

Icon.propTypes = {
  src: PropTypes.string.isRequired, // eslint-disable-line
  iconMeta: PropTypes.shape({
    viewBox: PropTypes.string.isRequired,
    error: PropTypes.bool
  }),
  style: stylePropType,
  fill: PropTypes.string,
  stroke: PropTypes.string,
  color: PropTypes.string,
  className: PropTypes.string
};

Icon.defaultProps = {
  iconMeta: null,
  style: null,
  fill: null,
  stroke: null,
  color: null,
  className: ''
};

styles = StyleSheet.create({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  errorContainer: {
    width: '2rem',
    height: '2rem',
    border: '1px solid #999999',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
});

export default enhance(Icon);